(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["game-guide"]) return;
  try {
    
  function setupGameGuides(root) {
    root.querySelectorAll('.game-guide').forEach(guide => {
      if (guide.dataset.ready) return;
      guide.dataset.ready = 'true';
      const select = guide.querySelector('[data-console-choice]');
      if (!select) return;
      const cards = [...guide.querySelectorAll('[data-console-handle]')];
      const requested = new URLSearchParams(window.location.search).get('console');
      const initial = cards.find(card => card.dataset.consoleHandle === requested) || cards.find(card => card.dataset.available === 'true') || cards[0];
      const show = handle => {
        cards.forEach(card => { card.hidden = card.dataset.consoleHandle !== handle; });
        select.value = handle;
      };
      if (initial) show(initial.dataset.consoleHandle);
      select.addEventListener('change', () => show(select.value));
    });
  }
  setupGameGuides(document);
  document.addEventListener('shopify:section:load', () => setupGameGuides(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
